import React from 'react';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const UploadFichier = ({ disabled = false,value = [], onChange  }) => {

   const handleChange = info => {
    if (onChange) {
      onChange(info.fileList);
    }
  };
  return (
    <div><br/>
     <Upload
          disabled={disabled}
          fileList={Array.isArray(value) ? value : []}
          onChange={handleChange}
          beforeUpload={() => false}
        >
          <Button icon={<UploadOutlined />}>Importer un fichier</Button>
     </Upload>

    </div>
  );
};

export default UploadFichier;
 